import { useRef } from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Content_Text } from "./Component/theme";

const Contanier = styled.div`
  display: flex;
  align-items: top;
  justify-content: center;
  width: 100%;
  height: 100dvh;
  background-color: #f1f1f1;
  overflow: auto;
`;
const ConBox = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  max-width: 800px;
  background-color: white;
  overflow: hidden;
`;
const Header = styled.div`
  z-index: 1;
  width: 100%;
  padding: 1rem 0rem;
  max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  box-shadow: 0px 3px 5px #eeeeee;
`;
const Pic = styled.div`
  flex: 1;
  overflow: auto;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  div.step2 {
    position: relative;
  }
`;
const BtnArea = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  width: 22rem;
  margin-top: 1rem;
  &.none {
    display: none;
  }
  div {
    width: 6.5rem;
    padding: 0.5rem 0rem;
    text-align: center;
    color: gray;
    border: 1px solid #eeeeee;
    border-radius: 50px;
    cursor: pointer;
  }
  div.check {
    color: white;
    background-color: #f71410;
    border: 1px solid #f71410;
  }
`;
const Pic_use = styled.img`
  width: 100%;
`;
const IconBox = styled.div`
  position: absolute;
  background-color: transparent;
  top: 20.2%;
  right: 0;
  margin-right: 20%;
  width: 60%;
  height: 2%;
  cursor: pointer;
`;

const Rosepay_use = () => {
  const { seq } = useParams();

  const picRef = useRef();
  const STEP1ref = useRef();
  const STEP2ref = useRef();
  const STEP3ref = useRef();

  const [scroll_height, setScroll_height] = useState(0);
  const [menu, setMenu] = useState("top");

  // picRef 높이 측정
  useEffect(() => {
    if (picRef.current) {
      const scrollHeight = picRef.current.scrollHeight;
      setScroll_height(scrollHeight);
    }
  }, []);

  useEffect(() => {
    if (seq === "2") return go_buy("auto");
    go_top("auto");
  }, [seq]);

  // scroll 위치에 따른 menu 지정
  const menu_about_scroll = () => {
    if (!picRef.current) return;

    const scrollPosition = picRef.current.scrollTop;
    const scrollHeight =
      picRef.current.scrollHeight - picRef.current.clientHeight;

    if (scrollPosition >= scrollHeight * 0.8) return setMenu("pay");
    if (scrollPosition >= scrollHeight * 0.415) return setMenu("buy");
    setMenu("top");
  };

  // 스토어 이동
  const go_top = (behavior) =>
    STEP1ref.current?.scrollIntoView({
      behavior: behavior,
      block: "start",
    });
  const go_buy = (behavior) => {
    STEP2ref.current?.scrollIntoView({
      behavior: behavior,
      block: "start",
    });
  };
  const go_pay = () => {
    STEP3ref.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const go_store = () => {
    if (isIos) {
      window.location.href =
        "https://apps.apple.com/kr/app/%EC%98%A8%EB%88%84%EB%A6%AC%ED%8E%98%EC%9D%B4-%EB%AA%A8%EB%B0%94%EC%9D%BC-%EC%98%A8%EB%88%84%EB%A6%AC%EC%83%81%ED%92%88%EA%B6%8C/id6464002044";
    } else {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.bizplay.pay.onnuri&hl=ko";
    }
  };

  const CurMenu = (type) => {
    if (menu === type) return "check";
    return "";
  };

  return (
    <Contanier>
      <ConBox>
        <Header>
          <Content_Text $xbold $xmlarge>
            로즈페이 이용방법
          </Content_Text>

          <BtnArea className={scroll_height === 0 ? "none" : ""}>
            <div onClick={() => go_top("smooth")} className={CurMenu("top")}>
              주문방법
            </div>
            <div onClick={() => go_buy("smooth")} className={CurMenu("buy")}>
              상품권 구매
            </div>
            <div onClick={go_pay} className={CurMenu("pay")}>
              결제진행
            </div>
          </BtnArea>
        </Header>

        <Pic ref={picRef} onScroll={menu_about_scroll}>
          <Pic_use ref={STEP1ref} src={require("./image/rosepay/1.png")} />

          <div className="step2">
            <Pic_use ref={STEP2ref} src={require("./image/rosepay/2.jpg")} />
            <IconBox onClick={go_store} />
          </div>

          <Pic_use ref={STEP3ref} src={require("./image/rosepay/3.png")} />
        </Pic>
      </ConBox>
    </Contanier>
  );
};

export default Rosepay_use;
